"use client";

import generateId from "../../utils/generateId";

export interface TabPanelProps extends React.HTMLAttributes<HTMLDivElement> {
  /** Optional href for the tab */
  href?: string;
  /** Tabpanel id */
  id?: string;
  /** Active state */
  isActive?: boolean;
  /** Whether the tab is disabled */
  isDisabled?: boolean;
  /** Tab content/label */
  tab?: React.ReactNode;
  /** Custom render function for tab */
  renderTab?: (props: TabPanelProps) => React.ReactElement;
  /** Additional class names */
  className?: string;
  /** Children components */
  children?: React.ReactNode;
}

const TabPanel: React.FC<TabPanelProps> = ({
  children,
  isActive,
  id,
  href,
  isDisabled,
  ...other
}) => {
  const currentId = id || generateId();

  return (
    <div
      id={currentId}
      role={href ? "" : "tabpanel"}
      tabIndex={0}
      hidden={!isActive}
      {...other}
    >
      {children}
    </div>
  );
};

TabPanel.displayName = "TabPanel";

export { TabPanel };
